var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-8 mb-4",staticStyle:{"min-width":"816px","max-width":"816px","min-height":"1056px"},attrs:{"elevation":"5"}},[_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }